<template>
  <v-application v-if="access.setting_payment_types">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("payment_types") }}</v-toolbar-title>
      </v-toolbar>
      <v-list two-line>
        <v-divider />
        <template v-for="(payment_type, payment_type_index) in payment_types">
          <v-list-item v-bind:key="payment_type_index">
            <v-list-item-action>
              <v-checkbox
                v-bind:disabled="!payment_type.enable"
                v-model="payment_type.status"
              />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ payment_type.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-bind:key="'payment_type_' + payment_type_index" />
        </template>
      </v-list>
      <template #actions>
        <v-btn text v-on:click="payment_type_cancel">{{ $t("cancel") }}</v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="payment_type_save"
          :loading="update_loading"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Payment from "../../mixins/payment";
export default {
  name: "SettingPayment",
  data: () => ({
    update_loading: false,
  }),
  mixins: [Payment],
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>